export const gallerySearch = (e, getAdImageData, setFullImagesArray, getAdInsertImageData, setInsertClonedArray) => {

    let results = [];
    let results1 = [];
    let toSearch = e.target.value.toUpperCase()

    getAdImageData.map((data1) => {
        if (data1.description.toUpperCase().indexOf(toSearch) != -1)
            results.push(data1);
    })
    let uniqResults = [...new Set(results)];

    setFullImagesArray(uniqResults)

    getAdInsertImageData.map((data1) => {
        if (data1.description.toUpperCase().indexOf(toSearch) != -1)
            results1.push(data1);
    })
    let uniqResults1 = [...new Set(results1)];

    setInsertClonedArray(uniqResults1)
}